import { render } from "./App.vue?vue&type=template&id=a8da21f2&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=a8da21f2&lang=scss"

import exportComponent from "/home/klaus/Dokumente/Projekte/Hochzeit/wedding-slideshow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__